<template>
  <div>
    <!-- <Loading :visible="true"></Loading> -->
    <div class="wrap reservation-coaching-wrap">
      <div class="top-header">
        <h3>나의 코칭</h3>
      </div>
      <div class="body-wrap" style="min-height: 500px">
        <incMenu></incMenu>
        <div class="reservation-info">
          <p>
            나의 회기 | <b>{{ mySession }}</b> <span>(코칭이 완료된 기준입니다.)</span>
          </p>
        </div>
        <div v-if="!list.length">
          <p class="txt-center">예약된 코칭이 없습니다.</p>
        </div>
        <div class="reservation-list w-90per mg-auto" v-else>
          <ul>
            <li class="clear" @click="next(item.sessionIdx)" v-for="(item, index) in list" :key="index">
              <div class="float-left coach-img" style="width: 76px; height: 82px">
                <img :src="item.coarPic" style="width: 100%" />
              </div>
              <div class="float-left coach-info">
                <span :class="{ request: item.sessionStatus == 1, complate: item.sessionStatus != 1 }">{{ item.sessionStatusName }}</span>
                <h1>{{ item.coachName }} <b>코치</b></h1>
                <p>{{ item.startDatetime }}({{ item.day }}) {{ item.start_time }} ~ {{ item.end_time }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import incMenu from "@/components/inc/inc_menu.vue";
import incTab from "@/components/inc/inc_tab.vue";
import dayjs from "dayjs";
// import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "reservation_coaching",
  data: () => ({
    list: [],
    weekday: ["일", "월", "화", "수", "목", "금", "토"],
    mySession: "",
    detailList: "",
    currentCoarching: 0,
  }),
  components: {
    incTab,
    incMenu,
    // Loading
  },
  mounted() {
    // console.log(dayjs("2022-02-28 21:00:00.0").format("HH:mm"))

    // console.log("token",localStorage.getItem("accessToken"))
    this.getCoarchingIdx();
    this.getReservationList();
    this.getSession();
    this.detailList = setInterval(() => {
      this.getCoarchingIdx();
      this.getReservationList();
      this.getSession();
    }, 100);
  },
  methods: {
    getCoarchingIdx() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
        courseIdx: this.$store.state.userInfo.courseIdx,
      };
      this.axios
        .get("/front/find/coarchingidx", { params })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            let tempCoarching = res.data.data;
            this.currentCoarching = tempCoarching[0].coarchingIdx;
            this.getSession();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSession() {
      let params = {
        courseIdx: this.currentCoarching,
      };
      this.axios
        .get("/front/left/session", { params })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            this.mySession = res.data.contentinfo.cnt;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getReservationList() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/front/coarching/reserved/list", { params })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            this.list = res.data.data;
            for (let item of this.list) {
              item.start_time = dayjs(item.startDatetime).format("HH:mm");
              item.end_time = dayjs(item.endDatetime).format("HH:mm");
              let dayTime = dayjs(item.startDatetime).format("YYYY/MM/DD");
              item.day = this.weekday[dayjs(dayTime).day()];

              item.startDatetime = dayjs(item.startDatetime).format("YYYY.MM.DD");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    next(sessionIdx) {
      this.$router.push({ name: "reservation_coaching_view", params: { sessionIdx: Number(sessionIdx) } });
    },
  },
  destroyed() {
    clearInterval(this.detailList);
  },
};
</script>
